import {
    SET_MEDIAS,
    SET_MEDIAS_ERROR,
    SET_UPLOADED_MEDIAS,
    SET_MEDIA_PREVIEW,
    SET_MEDIA_UPDATE,
    SET_MEDIA_UPLOAD,
    SET_MEDIA_NAME_INVALID,
    ADD_MEDIA_LABEL_SUGGESTION,
    REMOVE_MEDIA_LABEL_SUGGESTION,
    SET_MEDIA_LIST,
    SET_MEDIAS_LOADING,
} from './mutation-types';
import MissionMediasAPI from '~/services/api/MissionMediasAPI';

/**
  * Set medias for a product
  * @param {object} state - the vuex state object
  * @param {string} offerItemId - Id of Product the medias are attached to
  * @param {array} payload - array of medias
 */
export async function setMedias({ commit }, { offerItemId, payload }) {
  commit(SET_MEDIAS, { offerItemId, payload });
}

/**
  * Set preview for a media
  * @param {object} state - the vuex state object
  * @param {string} offerItemId - Id of Product the media is attached to
  * @param {object} mediaId - Id of the media the preview is attached to
  * @param {object} preview - media
 */
 export async function setMediaPreview({ commit }, {
    offerItemId, mediaId, previews, rawFile, fileId,
  }) {
  commit(SET_MEDIA_PREVIEW, {
    offerItemId, mediaId, previews, rawFile, fileId,
  });
}

export async function deleteMediaFile(store, { id }) {
  return MissionMediasAPI.deleteMediaFile(id);
}

/**
 * Fetch Mission Medias
 * @param {function} commit - The vuex commit function
 * @param {string} missionId - The mission ID
 */
 export async function fetchMissionMedias({ commit }, missionId) {
  try {
      commit(SET_MEDIAS_LOADING, true);
   const responseMedias = await MissionMediasAPI.fetchMissionMedias(missionId);
   const medias = responseMedias.data.reduce((results, media) => {
     const offerItemId = media.attributes.offer_item_id;
     (results[offerItemId] = results[offerItemId] || []).push(media);
    return results;
}, {});
   commit(SET_MEDIA_LIST, responseMedias.data);
   commit(SET_UPLOADED_MEDIAS, medias);
  } catch (err) {
    commit(SET_MEDIAS_ERROR, {
      err,
    });
  }
    commit(SET_MEDIAS_LOADING, false);
}

/**
 * Fetch Mission single Media
 * @param {function} commit - The vuex commit function
 * @param {string} missionId - The mission ID
 * @param {string} mediaId - The mission ID
 */
 export async function fetchMissionMedia({ commit }, { missionId, mediaId }) {
  const media = await MissionMediasAPI.fetchMedia(missionId, mediaId);
  if (media) {
      const { data } = media;
      commit(SET_MEDIA_UPDATE, { mediaId, updatedMedia: data });
    }
  return Promise.resolve(media);
}

export function updateMediaList({ commit }, offerId) {
  commit(SET_MEDIA_UPLOAD, offerId);
}

/**
  * Mark media that has invalid name
  * @param {object} state - the vuex state object
  * @param {object} mediaId - Id of the media the preview is attached to
  * @param {boolean} unmark - to add or remove the mediaId
 */
export async function setInvalidMediaName({ commit }, { mediaId, unmark }) {
  commit(SET_MEDIA_NAME_INVALID, { mediaId, unmark });
}

export async function addSuggestion({ commit }, label) {
    if (label !== null) {
        commit(ADD_MEDIA_LABEL_SUGGESTION, { label });
    }
}

export async function removeSuggestion({ commit }, label) {
    commit(REMOVE_MEDIA_LABEL_SUGGESTION, { label });
}
